/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { CamelCase, PriceHandler } from '../../../../redux/helper/CamelCase';

export default function EUBSummary({ OrderDetails }) {
    const [type, settype] = useState('revised');

    return (
        <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
            <div className="border-b border-[#CBCBCB] pb-2.5 flex justify-between items-start">
                <div className="">
                    <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                    <p className="sm:text-lg text-base font-normal text-[#555259]" data-testid="order-type">Trade EUB Order</p>
                </div>
                <p className="font-normal text-xs3 text-[#555259]">
                    Total Order Qty.:
                    {Object.keys(OrderDetails?.summary?.quantity).length > 0 && Object.keys(OrderDetails?.summary?.quantity).map((UOM, i) => (
                        <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className="font-semibold">
                            {Number(OrderDetails?.summary?.quantity[UOM])}
                            {' '}
                            {UOM}
                            {' '}
                            <br />
                        </span>
                    ))}

                </p>
            </div>
            <div className="pt-1.5">
                <ul className="nav nav-pills flex list-none pl-0 pb-1.5 border-b border-[#CBCBCB]" id="pills-tab" role="tablist">
                    <li onClick={() => settype('propose')} className="nav-item w-1/2 text-center" role="presentation">
                        <a href="javascript:void(0)" className={`w-full nav-link block text-xs26 font-semibold text-[#808285] view-order-summary ${type === 'propose' ? 'active' : ''} relative`} id="pills-propose-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                            Proposed Summary
                        </a>
                    </li>
                    <li onClick={() => settype('revised')} className="nav-item w-1/2 text-center" role="presentation">
                        <a href="javascript:void(0)" className={`w-full nav-link block text-xs26 font-semibold text-[#808285] view-order-summary ${type === 'revised' ? 'active' : ''} relative`} id="pills-invoices-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                            Revised Summary
                        </a>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className={`tab-pane fade ${type === 'propose' ? 'show active' : ''}`} id="pills-home" role="tabpanel" aria-labelledby="pills-propose-tab">
                        <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.order_value)}
                                </p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.total_discount)}</p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Add. Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.proposed_additional_discount)}</p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.dap_charges)}
                                </p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Amount</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.summary.proposed_net_amount)}</p>
                            </div>
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-sm text-[#555259] font-normal">Ador Cash redeemed </p>
                                <p className="sm:text-base font-semibold text-[#000000]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails?.summary.proposed_avail_ador_cash : 0)}</p>
                            </div>
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Value</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails.summary.ador_cash_proposed_net_amount : OrderDetails.summary.proposed_net_amount)}</p>
                            </div>
                        </div>
                        <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)*</p>
                                <p className="sm:text-xs18 text-base font-semibold text-[#555259]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails.summary.proposed_gst.ador_cash_avail_gst : OrderDetails.summary.proposed_gst.gst)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2 py-1">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-lg text-sm text-[#000000] font-normal">Gross Amount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#000000]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails.summary.ador_cash_proposed_gross_amount : OrderDetails.summary.proposed_gross_amount)}</p>
                            </div>
                        </div>
                    </div>
                    <div className={`tab-pane fade px-1 ${type === 'revised' ? 'show active' : ''}`} id="pills-profile" role="tabpanel" aria-labelledby="pills-invoices-tab">
                        <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {' '}
                                    {PriceHandler(OrderDetails?.summary?.order_value)}
                                    {' '}
                                </p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.total_discount)}</p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Add. Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.revised_additional_discount)}</p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.dap_charges)}
                                </p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Amount</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.summary?.revised_net_amount)}</p>
                            </div>
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-sm text-[#555259] font-normal">Ador Cash redeemed </p>
                                <p className="sm:text-base font-semibold text-[#000000]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails?.summary?.revised_avail_ador_cash : 0)}</p>
                            </div>
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Value</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails?.summary?.ador_cash_revised_net_amount : OrderDetails?.summary?.revised_net_amount)}</p>
                            </div>
                        </div>
                        <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)*</p>
                                <p className="sm:text-xs18 text-base font-semibold text-[#555259]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails?.summary?.revised_gst?.ador_cash_avail_gst : OrderDetails?.summary?.revised_gst?.gst)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2 py-1">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-lg text-sm text-[#000000] font-normal">Gross Amount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#000000]" data-testid="total-amount">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails?.summary?.ador_cash_revised_gross_amount : OrderDetails?.summary?.revised_gross_amount)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
